// extracted by mini-css-extract-plugin
export default {"lunbo":"index_lunbo_z8hAw","dotCurrent":"index_dotCurrent_ML-Dg","box":"index_box_ZbknE","image":"index_image_VR-rJ","link":"index_link_O7FfQ"};